import { ShieldCheck, Zap, Building2, Sparkles } from "lucide-react";
import { TRUST } from "../../data/site";
import { Reveal, SectionLabel } from "./Reveal";

const ICONS = [ShieldCheck, Zap, Building2, Sparkles];
const ABOUT_IMG = "/vans.jpg";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative overflow-hidden py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 lg:grid-cols-12 lg:px-8">
      <Reveal className="relative lg:col-span-6 lg:self-center">
        <div className="relative aspect-[4/3] overflow-hidden border border-white/10 shadow-[0_0_60px_rgba(30,155,255,0.15)]">
          <img src={ABOUT_IMG} alt="Pipe-Line UK branded vans" data-testid="about-image" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        </div>
        <div className="absolute -bottom-12 -right-2 border border-[#1E9BFF]/40 bg-black px-4 py-3 shadow-[0_0_40px_rgba(30,155,255,0.25)] sm:-bottom-6 sm:-right-6 sm:px-6 sm:py-5">
          <div className="font-display text-3xl font-extrabold text-[#1E9BFF] sm:text-4xl">100%</div>
          <div className="font-mono text-xs uppercase tracking-widest text-neutral-400">Commitment to quality</div>
        </div>
      </Reveal>
      <div className="pt-6 lg:col-span-6 lg:pl-8 lg:pt-0">
        <Reveal>
          <SectionLabel index="02">Why Choose Us</SectionLabel>
          <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Built on Experience.<br /><span className="metal-text">Driven by Standards.</span></h2>
          <p className="mt-8 text-neutral-300">Pipe-Line UK is a specialist drainage and utility contractor serving homeowners, landlords, builders and commercial clients. We combine modern diagnostic equipment with hands-on groundworks expertise to solve problems properly, not just patch them up.</p>
          <p className="mt-4 text-neutral-400">Whether it's an urgent blockage, a full site drainage scheme or a utility connection, you get honest advice, fixed quotes and a team that takes pride in leaving every site clean and tidy.</p>
        </Reveal>
        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {TRUST.map((t, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={t.title} delay={i * 90}>
                <div data-testid={`trust-point-${i + 1}`} className="trust-card flex gap-4 border border-white/10 bg-white/[0.02] p-6">
                  <Icon className="h-6 w-6 shrink-0 text-[#1E9BFF]" />
                  <div>
                    <div className="font-display text-lg font-bold uppercase">{t.title}</div>
                    <div className="mt-1 text-sm text-neutral-400">{t.text}</div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
